import type * as ImageCards from '../types/ImageCards'
import { imageParser } from '../props/parsers/Image'

function imageCardsSize(cardsLength: number) {
  switch (cardsLength) {
    case 2:
      return `large`
    case 3:
      return `medium`
    default:
      return `small`
  }
}

export default function imageCardsComponentParser(
  rawComponent: ImageCards.Raw,
): ImageCards.Parsed {
  const { cards, ...rest } = rawComponent.imageCards

  return {
    name: 'ImageCards',
    props: {
      ...rest,
      size: imageCardsSize(cards.length),
      cards: cards.map(({ image, ...card }) => ({
        ...imageParser(image),
        ...card,
      })),
    },
  }
}
